/**
 * Returns a validation error message for a password value, or an empty string if valid.
 */
export const getPasswordValidationError = (value) => {
    if (!value) return ''
    if (value.length < 8) return 'Password must be at least 8 characters'
    if (!/[A-Z]/.test(value)) return 'Password must include at least one uppercase letter'
    if (!/[a-z]/.test(value)) return 'Password must include at least one lowercase letter'
    if (!/[0-9]/.test(value)) return 'Password must include at least one number'
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) return 'Password must include at least one special character'
    return ''
}
